export default {
  getAll: {
    url: '/api/release/getAll',
    method: 'get'
  },
  create: {
    url: '/api/release/create',
    method: 'post'
  },
  update: {
    url: '/api/release/update',
    method: 'put'
  },
  delete: {
    url: '/api/release/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/release.js